import { render, staticRenderFns } from "./AlcoholWarning.vue?vue&type=template&id=2938364e"
import script from "./AlcoholWarning.vue?vue&type=script&lang=js"
export * from "./AlcoholWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports